import { useCMSData } from '../../state/content-manager';
import {
  PageLayout,
} from '../../components';
import { breakpoint, Heading } from '@grays-npm/component-library';
import styled from 'styled-components';

const StyledHeading = styled(Heading)`
  ${({ theme }) => theme.typography.headings[4]['xl']};

  ${breakpoint('lg')`
    ${({ theme }) => theme.typography.headings[3]['xl']};
  `}
`;

export const Contract = () => {
  const { contract } = useCMSData();
  return (
    <PageLayout>
      <StyledHeading size={4}>{contract.title}</StyledHeading>
      <div dangerouslySetInnerHTML={{ __html: contract.content }} />
    </PageLayout>
  );
};
